import React from "react";
import style from "./index.module.scss";
import { BaseQuestionType, EndExerciseQuestion } from "service/exercise";
import { htmlToPlain, replaceImgTag } from "utils/common";
import classNames from "classnames";

interface ListItemProps {
    index: number;
    data: EndExerciseQuestion;
    current: boolean;
    onSelect: () => void;
}

export default function ListItem({
    index,
    data,
    current,
    onSelect
}: ListItemProps) {
    return (
        <div
            className={classNames(style.root, { [style.current]: current })}
            role="button"
            onClick={onSelect}>
            <div className={style.header}>
                <span>
                    {index + 1}.（{data.queTypeName}，{data.score}分）
                </span>

                {data.queTypeId < BaseQuestionType.Mixed &&
                    data.queTypeId !== BaseQuestionType.Subjective && (
                        <span className={style.rate}>{data.accuracy}</span>
                    )}
            </div>

            <div className={style.content}>
                {htmlToPlain(data.contentText, replaceImgTag)}
            </div>

            <div className={style.footer}>
                作答正确 {data.stuRightList?.length || 0} 作答错误{" "}
                {data.stuUnRightList?.length || 0}
            </div>
        </div>
    );
}
